
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-35e77b08!stylus-loader?sourceMap!../../../../vue-loader/lib/selector?type=styles&index=0!./Saturation.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./Saturation.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-35e77b08!../../../../vue-loader/lib/selector?type=template&index=0!./Saturation.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-color/src/components/common/Saturation.vue
// module id = 298
// module chunks = 1